import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

const { onRequest, onSuccess, onFailure } = rootActions.demos.staticEnums
function* staticEnumsSagaTask() {
    try {
        const response = yield axios.get(`/companies/demos/static-enums`)
        if (response.success) {
            yield put(onSuccess(response.result))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* staticEnumsSaga(): any {
    yield takeLatest(onRequest, staticEnumsSagaTask)
}

export default staticEnumsSaga
